module.exports = __webpack_public_path__ + "img/kor.2d9b025f.svg";